module.exports = __webpack_public_path__ + "logo_bottom-70a9e7e1ffc243a19240fcc1e682fc4c.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/logo_bottom.png
// module id = 303
// module chunks = 0